import * as React from "react";
import {
    List,
    Show,
    Edit,
    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    NumberField,
    ArrayField,
    ReferenceField,

    TabbedShowLayout,
    Tab,
    BooleanInput,
    Create,
    PasswordInput,
    NumberInput,
    ImageField,
    useRecordContext,
    FileField,
    Button,
    sanitizeFieldRestProps,
    WrapperField,
    useRefresh,
    useUpdate,
    TabbedForm,
    Toolbar,
    SaveButton,
    InfiniteList,
    ReferenceManyCount,
    FunctionField,
    AutocompleteInput,
    EditButton,
    AutocompleteArrayInput,
    SimpleFormIterator,
} from 'react-admin';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import get from 'lodash/get';
import { Typography, Link } from '@mui/material';
import { apiUrl, authenticatedApi } from "../dataProvider";
import { objectToSelectChoices, stateAbbrToName, states } from "../helpers/strings";
import { TabCount } from "../Components/TabCount";
import { ReferenceManyInput, ReferenceManyToManyInput } from "@react-admin/ra-relationships";
import { UserOptionRenderer } from "../Components/OptionRenderer";

const listFilters = [
    <TextInput source="q" label="Search" alwaysOn />,

];
const CoordinatingProgramList = (props) => (
    <InfiniteList {...props} sort={{ field: 'name', order: 'ASC' }} filters={listFilters} exporter={false}>
        <Datagrid rowClick="show">
            <TextField label="Name" source="name" />
            <FunctionField label="State" source="state" render={record => stateAbbrToName(record.state)} />
            <FunctionField label="Communities" render={record => `${record.communities.length}`} />
            <EditButton/>
        </Datagrid>
    </InfiniteList>
);

const CoordinatingProgramShow = (props) => (
    <Show {...props} title={'View Coordinating Program'}>
        <TabbedShowLayout>
            <Tab label="Summary">
                <SimpleShowLayout>
                    <TextField source="name" />
                    <FunctionField label="State" source="state" render={record => stateAbbrToName(record.state)} />
                    <TextField source="member_number" />
                </SimpleShowLayout>
            </Tab>
            <Tab label="Communities" count={<TabCount source="communities" />}>
                <ArrayField source="communities" label={false}>
                    <Datagrid rowClick={(id, resource, record) => '/communities/'+id+'/show'} bulkActionButtons={false} sort={{field: 'name'}}>
                        <TextField sortable={false} source="name" />
                        <TextField sortable={false} source="city" />
                        {/* <DateField source="created_at" label={'Created'} /> */}
                    </Datagrid>
                </ArrayField>
            </Tab>
            <Tab label="Users" count={<TabCount source="users" />}>
                <ArrayField source="users" label={false}>
                    <Datagrid bulkActionButtons={false}>
                        <TextField sortable={false} source="name" />
                        <TextField sortable={false} source="email" label="Email" />
                    </Datagrid>
                </ArrayField>
            </Tab>
        </TabbedShowLayout>
    </Show>
);

const EditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

const CoordinatingProgramEdit = (props) => (
    <Edit {...props} title={'Edit Coodinating Program'} redirect="show"  mutationMode="pessimistic">
        <TabbedForm>
            <TabbedForm.Tab label="Summary">
                <TextInput source="name" isRequired />
                <AutocompleteInput source="state" choices={objectToSelectChoices(states)} />
                <TextInput source="member_number" />
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Communities">
                <em>Note: please edit each individual community to attach it to this coordinating program.</em>

                {/*
                <em>Note: please create new communities under the "Communities" section before attempting to add them below.</em>

                {/*  through="coordinating-program-user" using="coordinating_program_id,user_id" *\/}
                <ReferenceManyInput reference="communities" target="coordinating_program_id" perPage={-1}>
                    <SimpleFormIterator inline>
                        <TextInput source="name" />
                        <AutocompleteInput label="Community" inputText={choice => choice.name} />
                    </SimpleFormIterator>
                </ReferenceManyInput>
                */}
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Users">
                <Alert severity="warning" sx={{marginBottom: '0.5rem'}}>Please create new users under the "Users" section before attempting to add them below.</Alert>
                <Alert severity="info"><b>Only add users if they a staff member of the coordinating program.</b><br/>Adding a user to a coordinating program will give them permission to review all form entries for that program(s).<br/>Do not give this access to local program users.</Alert>

                <ReferenceManyToManyInput reference="users" through="coordinating-program-user" using="coordinating_program_id,user_id" perPage={-1} perPageChoices={-1}>
                    <AutocompleteArrayInput label="User" optionText={<UserOptionRenderer/>} inputText={choice => choice.name} />
                </ReferenceManyToManyInput>
            </TabbedForm.Tab>
        </TabbedForm>
    </Edit>
);


const CoordinatingProgramCreate = (props) => (
    <Create {...props} title={'New Coodinating Program'} redirect="show"  mutationMode="pessimistic">
        <TabbedForm>
            <TabbedForm.Tab label="Summary">
                <TextInput source="name" isRequired />
                <AutocompleteInput source="state" choices={objectToSelectChoices(states)} />
                <TextInput source="member_number" />
            </TabbedForm.Tab>
            {/* <TabbedForm.Tab label="Communities">COMING SOON</TabbedForm.Tab> */}
            <TabbedForm.Tab label="Users">
                <Alert severity="warning" sx={{marginBottom: '0.5rem'}}>Please create new users under the "Users" section before attempting to add them below.</Alert>
                <Alert severity="info"><b>Only add users if they a staff member of the coordinating program.</b><br/>Adding a user to a coordinating program will give them permission to review all form entries for that program(s).<br/>Do not give this access to local program users.</Alert>

                <ReferenceManyToManyInput reference="users" through="coordinating-program-user" using="coordinating_program_id,user_id" perPage={-1} perPageChoices={-1}>
                    <AutocompleteArrayInput label="User" optionText={<UserOptionRenderer/>} inputText={choice => choice.name} />
                </ReferenceManyToManyInput>
            </TabbedForm.Tab>
        </TabbedForm>
    </Create>
);

export {CoordinatingProgramList, CoordinatingProgramShow, CoordinatingProgramEdit, CoordinatingProgramCreate};
